import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import TripCard from './TripCard';
const TripSection = () => {
  const [activeTab, setActiveTab] = useState('UMRAH');
  // Sample trip data for each category
  const trips = {
    UMRAH: [{
      id: 1,
      image: 'https://images.unsplash.com/photo-1597546276341-b7e1088e3083?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
      duration: '11 DAYS',
      cities: '5N MAKKAH | 4N MADINAH',
      name: 'Classic Umrah Journey',
      price: 5057,
      description: 'Experience the spiritual journey with our most popular Umrah package.'
    }, {
      id: 2,
      image: 'https://images.unsplash.com/photo-1564769625905-50e93615e769?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
      duration: '14 DAYS',
      cities: '7N MAKKAH | 5N MADINAH',
      name: 'Extended Umrah Experience',
      price: 6299,
      description: 'A comprehensive Umrah journey with extended stays in both holy cities.'
    }, {
      id: 3,
      image: 'https://images.unsplash.com/photo-1565689876697-e467b6c54da2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
      duration: '9 DAYS',
      cities: '4N MAKKAH | 3N MADINAH',
      name: 'Essential Umrah Package',
      price: 4299,
      description: 'A concise yet fulfilling Umrah experience for those with limited time.'
    }],
    INTERNATIONAL: [{
      id: 4,
      image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
      duration: '10 DAYS',
      cities: 'PARIS | ROME | BARCELONA',
      name: 'European Highlights',
      price: 3899,
      description: "Explore the best of Europe's iconic cities and landmarks."
    }, {
      id: 5,
      image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
      duration: '12 DAYS',
      cities: 'TOKYO | KYOTO | OSAKA',
      name: 'Japan Discovery',
      price: 4599,
      description: "Immerse yourself in Japan's rich culture, history and natural beauty."
    }, {
      id: 6,
      image: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
      duration: '14 DAYS',
      cities: 'CAIRO | LUXOR | ASWAN',
      name: 'Egypt Explorer',
      price: 3299,
      description: 'Discover the wonders of ancient Egypt along the Nile River.'
    }],
    ASEAN: [{
      id: 7,
      image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
      duration: '7 DAYS',
      cities: 'BANGKOK | PHUKET',
      name: 'Thailand Delight',
      price: 1299,
      description: "Experience Thailand's vibrant culture, cuisine and beautiful beaches."
    }, {
      id: 8,
      image: 'https://images.unsplash.com/photo-1512291313931-d4291048e7b6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
      duration: '6 DAYS',
      cities: 'BALI | LOMBOK',
      name: 'Indonesian Paradise',
      price: 1499,
      description: "Relax and unwind in Indonesia's most beautiful islands."
    }, {
      id: 9,
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
      duration: '5 DAYS',
      cities: 'HANOI | HA LONG BAY',
      name: 'Vietnam Heritage',
      price: 1199,
      description: "Discover Vietnam's rich history, culture and natural wonders."
    }]
  };
  return <div className="py-16 bg-white" data-id="element-553">
      <div className="container mx-auto px-4 md:px-8" data-id="element-554">
        <div className="flex flex-col md:flex-row justify-between items-center mb-10" data-id="element-555">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-0" data-id="element-556">
            OUR POPULAR TRIPS!
          </h2>
          <Link to={`/${activeTab.toLowerCase()}`} className="flex items-center text-gold-500 hover:text-gold-600 font-medium" data-id="element-557">
            VIEW ALL
            <ArrowRight size={18} className="ml-1" data-id="element-558" />
          </Link>
        </div>
        {/* Category Tabs */}
        <div className="flex flex-wrap gap-2 mb-10 border-b border-gray-200" data-id="element-559">
          {Object.keys(trips).map(category => <button key={category} onClick={() => setActiveTab(category)} className={`px-6 py-3 font-medium text-sm ${activeTab === category ? 'text-gold-500 border-b-2 border-gold-500' : 'text-navy-700 hover:text-navy-900'}`} data-id="element-560">
              {category}
            </button>)}
        </div>
        {/* Trip Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-561">
          {trips[activeTab].map(trip => <TripCard key={trip.id} trip={trip} data-id="element-562" />)}
        </div>
      </div>
    </div>;
};
export default TripSection;